import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExportToCsv } from 'export-to-csv';

@Injectable({
    providedIn: 'root'
})
export class ExportCSVService {

    constructor(private http: HttpClient) {
    }

    exportCSV(options, dataObject) {
        const option = {
            filename: options.filename,
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: options.showTitle,
            title: options.title,
            useTextFile: options.useTextFile,
            useBom: true,
            useKeysAsHeaders: options.useKeysAsHeaders,
            headers: options.headers
        };

        const csvExporter = new ExportToCsv(option);

        csvExporter.generateCsv(dataObject);
    }

}